import { takeLatest, call, put } from 'redux-saga/effects';
import * as departmentActions from 'redux/ducks/Department/DepartmentDucks';
import * as alertActions from 'redux/ducks/common/alertDucks';
import employeeApi from 'api/employee/employeeApi';

export function* createDepartment({ payload }) {
  try {
    const response = yield call(employeeApi.createDepartment, payload);
    yield put(departmentActions.createDepartmentSuccess(response));
    yield put(departmentActions.updateDepartment(payload));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorMessage] }));
  }
}

export function* deleteDepartment({ payload }) {
  try {
    const response = yield call(employeeApi.deleteDepartment, payload);
    yield put(departmentActions.deleteDepartmentSuccess(response));
    yield put(departmentActions.removeDepartment(payload));
  } catch (error) {
    yield put(departmentActions.deleteDepartmentFail(error));
    yield put(alertActions.open({ message: [error.errorMessage] }));
  }
}
export default function* JobTitleSaga() {
  yield takeLatest(departmentActions.createDepartment, createDepartment);
  yield takeLatest(departmentActions.deleteDepartment, deleteDepartment);
}
